<div class="w-full h-full">
    <div class="flex items-center justify-between space-x-3 pt-7 text-sm">
        <div class="flex items-center"></div>
        <div class="flex items-center pl-16">
            <button class="custom-tabbtn text-xs cursor-default focus:outline-none py-3 px-3 uppercase font-bold btn-light-orange-no">
                FRAUD PREVENTION
            </button>
        </div>
        <div class="flex items-center space-x-3 pr-10">
            <svg (click)="print()" class="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="20" height="21.433" viewBox="0 0 25 21.433">
                <g id="iconfinder_icon-printer_211880" transform="translate(-32 -64)">
                    <path id="Path_369" data-name="Path 369" d="M155.961,313.926h.541v-7.245a.7.7,0,0,0-.692-.681H144.692a.7.7,0,0,0-.692.681v7.245h11.961Z" transform="translate(-105.749 -228.493)"/>
                    <g id="Group_77" data-name="Group 77" transform="translate(32 64)">
                        <path id="Path_370" data-name="Path 370" d="M53.869,67.74H52.15V64.82a.856.856,0,0,0-.887-.82H37.743a.856.856,0,0,0-.887.82V67.74H35.137A3.34,3.34,0,0,0,32,70.787V77.53c0,1.518,1.58,3.444,3.137,3.444h1.021c.274,0,.307,0,.307-.781v-2.4A1.788,1.788,0,0,1,38.3,76.006H50.8c.988,0,1.736,1.189,1.736,2.233v1.954c0,.781.006.781.279.781h1.044a3.294,3.294,0,0,0,3.137-3V70.787A3.33,3.33,0,0,0,53.869,67.74Zm-1.328,3.4a.893.893,0,1,1,.893-.893A.9.9,0,0,1,52.54,71.144Z" transform="translate(-32 -64)"/>
                    </g>
                </g>
            </svg>
        </div>
    </div>

    <div class="w-full minh-550-px overflow-x-auto w-table pr-20">
        <!-- Search and Limit Controls -->
        <div class="w-full flex items-center justify-between space-x-3 pr-5 text-sm">
            <app-limit-control
                [currentLimit]="size"
                (limitChangeEvent)="onLimitChangeFromComponent($event)"
            ></app-limit-control>

            <app-search-control
                [searchPlaceholder]="'Search'"
                (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
                (keydownEvent)="keyDownFunction($event)"
            ></app-search-control>
        </div>

        <!-- Data Table -->
        <div class="data-table4 mt-3 barlow m-5" style="font-size: 12px;">
            <table class="w-full">
                <thead class="bg-light-orange">
                    <tr class="header-row" style="border-left: 1px #CAC2BC solid; border-right: 1px #CAC2BC solid;">
                        <th class="text-left barlow orange-text pl-2 pt-3 pb-3">
                            DATE/TIME
                        </th>
                        <th class="text-left barlow orange-text pl-2 pt-3 pb-3">
                            NAME
                        </th>
                        <th class="text-left barlow orange-text pl-2 pt-3 pb-3">
                            PHONE NUMBER
                        </th>
                        <th class="text-left barlow orange-text pl-2 pt-3 pb-3">
                            ACTION
                        </th>
                        <th class="text-left barlow orange-text pl-2 pt-3 pb-3">
                            REASON
                        </th>
                        <th class="text-left barlow orange-text pl-2 pt-3 pb-3">
                            REVIEW
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Data Rows -->
                    <ng-container *ngFor="let log of logsList; let i = index">
                        <tr 
                            class="table-row-not-expanded focus:outline-none" 
                            style="border-left: 1px #CAC2BC solid; border-right: 1px #CAC2BC solid; color: red; height: 40px;"
                        >
                            <td>
                                <div class="flex items-center">
                                    <!-- Toggle button - only show if remarks exist -->
                                    <button 
                                            class="material-icons lock-unlock w-30-px h-full focus:outline-none"
                                            (click)="toggleRemarks(i)">
                                        <img *ngIf="!log.showRemarks" 
                                            src="../../../../assets/images/icon/add%20icon%20(blue).png"
                                            alt="Show remarks">
                                        <img *ngIf="log.showRemarks" 
                                            src="../../../../assets/images/icon/minus%20icon%20(red).png"
                                            alt="Hide remarks">
                                    </button>
                                    {{ log.dateTime | date:'yyyy-MM-dd HH:mm:ss' }}
                                </div>
                            </td>
                            <td>{{ log.name | nullWithDefault }}</td>
                            <td>{{ log.phoneNumber | nullWithDefault }}</td>
                            <td>{{ log.action | nullWithDefault }}</td>
                            <td>{{ log.reason | nullWithDefault }}</td>
                            <td>{{ log.review | nullWithDefault }}</td>
                        </tr>
                        <!-- Remarks Row (shown only when toggled) -->
                        <tr *ngIf="log.showRemarks" 
                            class="table-row-not-expanded focus:outline-none" 
                            style="border-left: 1px #CAC2BC solid; border-right: 1px #CAC2BC solid;">
                            <td colspan="6" style="padding: 8px 0px 8px 20px;">
                                @if(log.remarks === null || log.remarks.length < 0 || log.remarks === ''){
                                    <p>No remarks available</p>
                                }@else{
                                    <p>Remarks {{ log.remarks }}</p>
                                }
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>

            <!-- Pagination Component Integration -->
            <app-pagination
                backgroundColor="bg-white"
                [currentPage]="current_page"
                [totalPages]="total_pages"
                [pageSize]="size"
                [totalItems]="total"
                (pageChange)="setPage($event)"
                (previousPage)="prevPage()"
                (nextPage)="nextPage()"
                showTotalEntries="true"
            ></app-pagination>
        </div>
    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>